import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 16 16"
  }, props),
  /* @__PURE__ */ React.createElement("g", { fill: "currentColor" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M13.333 4H2.667v8h10.666zM2.667 2.667c-.737 0-1.334.597-1.334 1.333v8c0 .736.597 1.333 1.334 1.333h10.666c.737 0 1.334-.597 1.334-1.333V4c0-.736-.597-1.333-1.334-1.333z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React.createElement("path", { d: "M2.667 4H6v8H2.667z" }))
);
var SvgViewModeLeftMenu = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ViewModeLeftMenu_default = SvgViewModeLeftMenu;

export { ViewModeLeftMenu_default as default };
